import React from 'react';

// Импортируем модульные стили
import styles from './Footer.module.css';

// Импортируем логотип
import logo from '../../assets/images/logo.svg';

// Можно импортировать иконки соцсетей, если они есть
// import { ReactComponent as InstagramIcon } from '../../assets/icons/social/instagram.svg';
// import { ReactComponent as LinkedInIcon } from '../../assets/icons/social/linkedin.svg';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.footerGrid}`}>
        
        {/* Колонка 1: Логотип и описание */}
        <div className={styles.footerColumn}>
          <a href="#home" className={styles.logo}>
            <img src={logo} alt="Логотип BRU.kz" />
            <span>BRU.kz</span>
          </a>
          <p className={styles.description}>
            Надежное оборудование для вашего строительства. Доставка по всему Казахстану и СНГ.
          </p>
        </div>

        {/* Колонка 2: Навигация */}
        <div className={styles.footerColumn}>
          <h4 className={styles.columnTitle}>Навигация</h4>
          <ul className={styles.linkList}>
            <li><a href="#benefits">Преимущества</a></li>
            <li><a href="#catalog">Каталог</a></li>
            <li><a href="#social-proof">Отзывы</a></li>
            <li><a href="#contact">Контакты</a></li>
          </ul>
        </div>

        {/* Колонка 3: Контакты */}
        <div className={styles.footerColumn}>
          <h4 className={styles.columnTitle}>Контакты</h4>
          {/* Используем тег <address> для семантически верного представления контактов */}
          <address className={styles.contactList}>
            <p><strong>Адрес:</strong> Алматы, Казахстан</p>
            <p>
              <strong>Телефон:</strong> 
              <a href="tel:+77771234567"> +7 (777) 123-45-67</a>
            </p>
            <p>
              <strong>Email:</strong> 
              <a href="mailto:info@bru.kz"> info@bru.kz</a>
            </p>
          </address>
        </div>

        {/* Колонка 4: Социальные сети */}
        <div className={styles.footerColumn}>
          <h4 className={styles.columnTitle}>Мы в соцсетях</h4>
          <div className={styles.socialIcons}>
            {/* 
              Ссылки-заглушки. В будущем можно заменить на реальные иконки.
              target="_blank" rel="noopener noreferrer" - обязательные атрибуты
              для безопасного открытия ссылок в новой вкладке.
            */}
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              {/* <InstagramIcon /> */} ИН
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              {/* <LinkedInIcon /> */} ЛН
            </a>
          </div>
        </div>

      </div>

      {/* Нижняя часть футера с копирайтом */}
      <div className={styles.footerBottom}>
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Bru.kz | Все права защищены.</p>
          <p><a href="#privacy-policy">Политика конфиденциальности</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;